/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */
import {ToolsHelper} from '../_helpers/tools-helper';

export interface OAuthToken {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: any;
  refresh_token: string;
}

export class Token {

  public accessToken: string;
  public expiresIn: number;
  public tokenType: string;
  public scope: any;
  public refreshToken: string;
  public timeCreated: number;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              STATIC METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public static fromOAuthToken(oAuthToken: OAuthToken): Token {
    const t = new Token();
    t.accessToken = oAuthToken.access_token;
    t.expiresIn = oAuthToken.expires_in;
    t.tokenType = oAuthToken.token_type;
    t.scope = oAuthToken.scope;
    t.refreshToken = oAuthToken.refresh_token;

    return t;
  }

  public static fromToken(token: Token): Token {
    const t = new Token();
    t.accessToken = token.accessToken;
    t.expiresIn = token.expiresIn;
    t.tokenType = token.tokenType;
    t.scope = token.scope;
    t.refreshToken = token.refreshToken;
    t.timeCreated = token.timeCreated;

    return t;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(timeCreated?: number) {
    this.timeCreated = timeCreated ? timeCreated : ToolsHelper.now();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUE GETTERS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get isExpired(): boolean {
    return ToolsHelper.now() >= (this.timeCreated + this.expiresIn * 0.9);
  }

}
